import { gql } from "@apollo/client";

export const USAGE_OF_SUBACCOUNT = gql`
  query usageOfSubaccount(
    $subaccountId: String!
    $startDate: String!
    $endDate: String!
  ) {
    usageOfSubaccountByDay(
      input: {
        subaccountId: $subaccountId
        startDate: $startDate
        endDate: $endDate
      }
    ) {
      date
      smsSegments
      smsMessages
      mmsMessages
      smsUnregisteredSegments
      smsUnregisteredMessages
      mmsUnregisteredMessages
      smsShortcodeSegments
      smsShortcodeMessages
      mmsShortcodeMessages
    }
    usageOfSubaccountByCampaign(
      input: {
        subaccountId: $subaccountId
        startDate: $startDate
        endDate: $endDate
      }
    ) {
      campaign {
        id
        shortId
        name
      }
      smsSegments
      smsMessages
      mmsMessages
      smsUnregisteredSegments
      smsUnregisteredMessages
      mmsUnregisteredMessages
      smsShortcodeSegments
      smsShortcodeMessages
      mmsShortcodeMessages
      donationCount
      recurringDonationCount
      amountRaisedInCents
    }
  }
`;

export const USAGE_OF_TENANT = gql`
  query usageOfTenant($startDate: String!, $endDate: String!) {
    usageOfTenantBySubaccount(
      input: { startDate: $startDate, endDate: $endDate }
    ) {
      subaccount {
        id
        name
        slug
        integrations {
          id
          service
        }
      }
      smsSegments
      smsMessages
      mmsMessages
      smsUnregisteredSegments
      smsUnregisteredMessages
      mmsUnregisteredMessages
      smsShortcodeSegments
      smsShortcodeMessages
      mmsShortcodeMessages
      donationCount
      recurringDonationCount
      amountRaisedInCents
    }
    usageOfTenantByDay(input: { startDate: $startDate, endDate: $endDate }) {
      date
      smsSegments
      smsMessages
      mmsMessages
      smsUnregisteredSegments
      smsUnregisteredMessages
      mmsUnregisteredMessages
      smsShortcodeSegments
      smsShortcodeMessages
      mmsShortcodeMessages
    }
  }
`;
